import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["Swiper"], {
    modules: $setup.modules,
    breakpoints: {
      0: {
        slidesPerView: 1.5,
      },
      640: {
        slidesPerView: 2.5,
      },
      768: {
        slidesPerView: 3.5,
      },
      1024: {
        slidesPerView: 4,
      },
    },
    "slides-per-view": 4,
    "space-between": 12,
    navigation: {
      prevEl: '.date-radio-slider-button--prev',
      nextEl: '.date-radio-slider-button--next',
    }
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dates, (date) => {
        return (_openBlock(), _createBlock($setup["SwiperSlide"], {
          key: date.date.toISOString()
        }, {
          default: _withCtx(() => [
            _createVNode($setup["DateCard"], {
              class: "date-radio-container",
              content: date.htmlContent,
              date: date.date,
              value: date.value,
              "model-value": $setup.selectedDate === date.value,
              onSelected: () => $setup.selectDate(date.date, date.value)
            }, null, 8 /* PROPS */, ["content", "date", "value", "model-value", "onSelected"])
          ]),
          _: 2 /* DYNAMIC */
        }, 1024 /* DYNAMIC_SLOTS */))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }))
}